import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import ko from './locales/ko.json';
import zh from './locales/zh.json';
import de from './locales/de.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ko: { translation: ko },
      zh: { translation: zh },
      de: { translation: de }
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'ko', 'zh', 'de'],
    load: 'languageOnly',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

const applyLang = (l) => { try { document.documentElement.lang = String(l || 'en').slice(0, 2); } catch (e) {} };
applyLang(i18n.language);
i18n.on('languageChanged', applyLang);

export default i18n;
